module.exports = "https://beta.voredev.ru/assets/index/chat-3290ad760715182290596883bb415166.svg";